export const actionTypes = {
  RESET: 'reset',
  SELECT_CUP: 'selectCup',
  SELECT_UNDERBUST: 'selectUnderbust',
  SET_SLIDE_INDEX: 'setSlideIndex',
};

export const initialState = {
  activeSlideIndex: 0,
  result: null,
  selectedCup: null,
  selectedUnderbust: '',
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_SLIDE_INDEX:
      return {
        ...state,
        activeSlideIndex: action.payload,
      };
    case actionTypes.SELECT_UNDERBUST:
      return {
        ...state,
        selectedUnderbust: action.payload,
      };
    case actionTypes.SELECT_CUP:
      return {
        ...state,
        result: action.payload?.results,
        selectedCup: action.payload,
      };
    case actionTypes.RESET:
    default:
      return initialState;
  }
};
